import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { Customer, ItemId, User } from '../types/items';
import { List, ListParams } from '../types/main';
import { transformList } from './transformer';

class UserService {
  private route = apis.users;

  constructor(private api: ApiService) {}

  template = () => this.api.get<Customer>(`${this.route.list}/new`);

  getCurrent = () => this.api.get<User>(this.route.current);

  list = (params: ListParams) => this.api
    .get<List<User>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<User>(`${this.route.id}/${id}`);

  save = (id: ItemId, data: User) => this.api.put(`${this.route.id}/${id}`, data);

  create = ({
    id,
    ref,
    permissions,
    ...user
  }: User) => this.api.post<User>(this.route.list, user);
}

export default new UserService(apiService);
